import AuthService from '../Services/authService';
import Comments from '../Elements/Comments';
import dateTimeHelper from '../Helpers/datetimeHelper';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import GetActualAssignmentFeeValue from '../Elements/GetActualAssignmentFeeValueText';
import GetActualLineItemValueText from '../Elements/GetActualLineItemValueText';
import JsxHelper from '../Helpers/JsxHelper';
import LogComponent from '../Elements/LogComponent';
import LookupText from '../Elements/LookupText';
import moneyHelper from '../Helpers/moneyHelper';
import PricingMain from '../Contents/Sales/PricingAdmin/PricingMain';
import React from 'react';
import ServiceActualData from '../Elements/ServiceActualData';
import ServiceItemAdmin from '../Contents/Sales/ServiceAdmin/ServiceItemAdmin';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import mathHelper from '../Helpers/mathHelper';
import urlHelper from '../Helpers/urlHelper';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import LongText from '../Elements/LongText';
import ShowNameComponent from '../Elements/ShowNameComponent';
import OfficeService from '../Services/OfficeService';
import ServicesSummary from '../Elements/Reports/ServicesSummary';
//import PricingSummary from '../Elements/Reports/PricingSummary';
import AttachmentsComponent from '../Elements/AttachmentsComponent';
import OpportunityCommissionRatesAdmin from '../Contents/User/CommissionRate/OpportunityCommissionRatesAdmin';
import OpportunitySecurityChecklistService from '../Services/opportunitySecurityChecklistService';
import OpportunitySecurityChecklistItem from './OpportunitySecurityChecklistItem';
import ShowEntityData from '../Elements/ShowEntityData';
import AdjustedPricingSummary from '../Elements/Reports/AdjustedPricingSummary';

class OpportunityItem {
  constructor(item) {
    if (item === undefined) {
      this.AcctRepId = '';
      this.ActualCloseOn = '';
      this.ActualEndOn = '';
      this.ActualEndOnOverrid = '';
      this.ActualStartOn = '';
      this.ActualValue = '';
      this.AssignedOn = '';
      this.AssignedTo = '';
      this.AssigneToName = '';
      this.BillingCurId = '';
      this.ClientId = '';
      this.ClientName = '';
      this.CompetitiveBid = '';
      this.CompetitorDetail = '';
      this.ContactId = '';
      this.ContactName = '';
      this.CreatedBy = '';
      this.CreatedOn = '';
      this.Description = '';
      this.EstCloseOn = '';
      this.EstEndOn = '';
      this.EstNumberOfVisits = '';
      this.EstStartOn = '';
      this.EstValue = '';
      this.FollowUpByDate = '';
      this.IndustryCode = '';
      this.InvoicingProcedures = '';
      this.IsGlobal = '';
      this.IsMspartner = '';
      this.IsProposalDelivered = '';
      this.KeyStakeholders = '';
      this.LeadId = '';
      this.LeadName = '';
      this.ModifiedBy = '';
      this.ModifiedOn = '';
      this.MspartnerCode = '';
      this.Name = '';
      this.NumBillToAddrs = '';
      this.OfficeId = '';
      this.OfficeName = '';
      this.OpportunityCurrency = '';
      this.OpportunityId = '';
      this.Owner = '';
      this.PastExperience = '';
      this.PrimarySalesRep = '';
      this.Probability = 0.0;
      this.ProgramObjectives = '';
      this.ProposalSentOn = '';
      this.ReasonLostCode = '';
      this.RecentResearch = '';
      this.SalesRepId = AuthService.getInstance().GetLoggedInUser().userId;
      this.StatusCode = '';
      this.StatusName = '';
      this.TypeCode = '';
      this.IsMultiOffice = '';
      this.PrimarySalesRepOfficeId = '';
      this.MaximumOpportunityDuration = null;
      return;
    }

    this.AcctRepId = item.acctRepId;
    this.ActualCloseOn = item.actualCloseOn;
    this.ActualEndOn = item.actualEndOn;
    this.ActualEndOnOverrid = item.actualEndOn;
    this.ActualStartOn = item.actualStartOn;
    this.ActualValue = item.actualValue;
    this.AssignedOn = item.assignedOn;
    this.AssignedTo = item.assignedTo;
    this.AssigneToName = item.assigneToName;
    this.BillingCurId = item.billingCurId;
    this.ClientId = item.clientId;
    this.ClientName = item.clientName;
    this.CompetitiveBid = item.competitiveBid;
    this.CompetitorDetail = item.competitorDetail;
    this.ContactId = item.contactId;
    this.ContactName = item.contactName;
    this.CreatedBy = item.createdBy;
    this.CreatedOn = item.createdOn;
    this.Description = item.description;
    this.EstCloseOn = item.estCloseOn;
    this.EstEndOn = item.estEndOn;
    this.EstNumberOfVisits = item.estNumberOfVisits;
    this.EstStartOn = item.estStartOn;
    this.EstValue = item.estValue;
    this.FollowUpByDate = item.followUpByDate;
    this.IndustryCode = item.industryCode;
    this.InvoicingProcedures = item.invoicingProcedures;
    this.IsGlobal = item.isGlobal;
    this.IsMspartner = item.isMspartner !== null ? item.isMspartner : false;
    this.IsProposalDelivered = item.isProposalDelivered;
    this.KeyStakeholders = item.keyStakeholders;
    this.LeadId = item.leadId;
    this.LeadName = item.leadName;
    this.ModifiedBy = item.modifiedBy;
    this.ModifiedOn = item.modifiedOn;
    this.MspartnerCode = item.mspartnerCode;
    this.Name = item.name;
    this.NumBillToAddrs = item.numBillToAddrs;
    this.OfficeId = item.officeId;
    this.OfficeName = item.officeName;
    this.OpportunityCurrency = item.opportunityCurrency;
    this.OpportunityId = item.opportunityId;
    this.Owner = item.owner;
    this.PastExperience = item.pastExperience;
    this.PrimarySalesRepId = item.primarySalesRepId;
    this.PrimarySalesRep = item.primarySalesRep;
    this.Probability = item.probability;
    this.ProgramObjectives = item.programObjectives;
    this.ProposalSentOn = item.proposalSentOn;
    this.ReasonLostCode = item.reasonLostCode;
    this.RecentResearch = item.recentResearch;
    this.SalesRepId = item.salesRepId;
    this.StatusCode = item.statusCode;
    this.StatusName = item.statusName;
    this.TypeCode = item.typeCode;
    this.IsMultiOffice = item.isMultiOffice;
    this.PrimarySalesRepOfficeId = item.primarySalesRepOfficeId;
    this.MaximumOpportunityDuration = null;
  }

  static NameOfTheIdField() {
    return 'OpportunityId';
  }

  static nameOfTheItemDetailList = (item) => (
    <LongText
      text={`Opportunity - ${item.Name} (#${item.OpportunityId})`}
      fitToBox
    />
  );
  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static NavigationDesc = ['ClientName'];
  static DateFields = [
    'FollowUpByDate',
    'EstCloseOn',
    'AssignedOn',
    'ProposalSentOn',
    'FollowUpByDate',
    'EstCloseOn',
    'EstStartOn',
    'EstEndOn',
    'ActualCloseOn',
    'ActualStartOn',
    'ActualEndOn',
  ];

  static BoolFields = [];

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: 'OpportunityId', label: 'Opportunity ID', className: 'text-left' },
        { name: 'PrimarySalesRep', label: 'Primary Sales Rep', className: 'text-left' },
        {
          name: (item) => (
            <ShowNameComponent
              id={item.PrimarySalesRepOfficeId}
              serviceFunction={OfficeService.GetOfficeNameById}
            />
          ),
          label: 'Primary Sales Rep Office Id',
          className: 'text-left',
        },
        { name: (item) => JsxHelper.YesNo(item.IsGlobal), label: 'Global', className: 'text-left' },
        { name: 'Name', label: 'Opportunity Name', className: 'text-left' },
        { name: 'Owner', label: 'Owner', className: 'text-left' },
        {
          name: (item) => JsxHelper.YesNo(item.IsMultiOffice),
          label: 'Multi Office Opportunity?',
          className: 'text-left',
        },
        {
          //name: (item) => `${item.ClientName} (${item.ClientId})`,

          name: OpportunityItem.GetClientCellContent,
          label: 'Client Name',
          className: 'text-left',
        },
        { name: 'ContactName', label: 'Contact ', className: 'text-left' },
        {
          name: (item) => (
            <LookupText
              lookupId={72}
              value={item.TypeCode}
            />
          ),
          label: 'Opportunity Type',
        },
        { name: 'OfficeName', label: 'Owning Office', className: 'text-left' },
        { name: 'OpportunityCurrency', label: 'Opportunity Currency', className: 'text-left' },
        { name: (item) => JsxHelper.YesNo(item.IsMspartner), label: 'Ms Partner', className: 'text-left' },
        {
          name: (item) => (
            <LookupText
              lookupId={83}
              value={item.MspartnerCode}
            />
          ),
          label: 'MS Partner ',
          className: 'text-left',
        },
        {
          name: 'Description',
          label: 'Description',
          width: TabListTableCellWidthEnum.TwoLines,
          className: 'text-left',
        },

        { name: '-', label: '' },
        { name: '-message-', label: 'Invoicing' },
        { name: 'NumBillToAddrs', label: 'No. Bill to Addresses', className: 'text-left' },
        {
          name: 'InvoicingProcedures',
          label: 'Invoicing Procedures',
          width: TabListTableCellWidthEnum.TwoLines,
          className: 'text-left',
        },

        { name: '-', label: '' },
        { name: '-message-', label: 'Source' },
        {
          name: OpportunityItem.GetLeadCellContent,
          label: 'Lead',
          className: 'text-left',
        },
        {
          name: (item) => (
            <LookupText
              lookupId={6}
              value={item.IndustryCode}
            />
          ),
          label: 'Industry',
        },

        { name: '-', label: '' },
        { name: '-message-', label: 'Status' },
        { name: 'StatusName', label: 'Status', className: 'text-left' },
        {
          name: (item) => (
            <LookupText
              lookupId={26}
              value={item.ReasonLostCode}
            />
          ),
          label: 'Reason Lost',
        },
        { name: 'AssigneToName', label: 'Assigned To', className: 'text-left' },
        {
          name: (item) => dateTimeHelper.toYYYYsMMsDDWithIndefinite(item.AssignedOn),
          label: 'Assigned On',
          className: 'text-left',
        },
        {
          name: (item) => dateTimeHelper.toYYYYsMMsDDWithIndefinite(item.ProposalSentOn),
          label: 'Date Proposal Sent',
          className: 'text-left',
        },
        {
          name: (item) => dateTimeHelper.toYYYYsMMsDDWithIndefinite(item.FollowUpByDate),
          label: 'Follow-up by Date',
          className: 'text-left',
        },

        { name: '-', label: '' },
        { name: '-message-', label: 'Estimates' },
        {
          name: (item) => mathHelper.ConvertToTwoDecimalNumber(item.Probability),
          label: 'Probability (%)',
          className: 'text-left',
        },
        { name: 'EstNumberOfVisits', label: 'Est. Number of Evaluations', className: 'text-left' },
        {
          name: (item) => <ServiceActualData OpportunityId={item.OpportunityId} />,
          label: 'Actual Number of Evaluations',
          className: 'text-left',
        },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.EstValue, item.OpportunityCurrency),
          label: 'Est. Value',
          className: 'text-left',
        },
        {
          name: (item) => dateTimeHelper.toYYYYsMMsDDWithIndefinite(item.EstCloseOn),
          label: 'Est. Close On (Won or Lost Date)',
          className: 'text-left',
        },
        {
          name: (item) => dateTimeHelper.toYYYYsMMsDDWithIndefinite(item.ActualCloseOn),
          label: 'Actual Close On (Won or Lost Date)',
          className: 'text-left',
        },
        {
          name: (item) => (
            <GetActualAssignmentFeeValue
              OpportunityId={item.OpportunityId}
              OpportunityCurrency={item.OpportunityCurrency}
            />
          ),
          label: 'Actual Assignment Fee Value',
          className: 'text-left',
        },
        {
          name: (item) => dateTimeHelper.toYYYYsMMsDDWithIndefinite(item.EstStartOn),
          label: 'Est. Start On',
          className: 'text-left',
        },
        {
          name: (item) => dateTimeHelper.toYYYYsMMsDDWithIndefinite(item.ActualStartOn),
          label: 'Actual Start On',
          className: 'text-left',
        },
        {
          name: (item) => (
            <GetActualLineItemValueText
              OpportunityId={item.OpportunityId}
              OpportunityCurrency={item.OpportunityCurrency}
            />
          ),
          label: 'Actual Line Item Value',
          className: 'text-left',
        },
        {
          name: (item) => dateTimeHelper.toYYYYsMMsDDWithIndefinite(item.EstEndOn),
          label: 'Est. End On',
          className: 'text-left',
        },
        {
          name: (item) => dateTimeHelper.toYYYYsMMsDDWithIndefinite(item.ActualEndOn),
          label: 'Actual End On',
          className: 'text-left',
        },
      ],
    },
    {
      tabName: 'Services',
      tabLabel: 'Services',
      icon: 'fa-solid fa-bell-concierge',
      data: [
        {
          name: (item) => (
            <ServiceItemAdmin
              Navigation={true}
              OpportunityId={item.OpportunityId}
              StatusCode={item.StatusCode}
            />
          ),
          label: 'Comments',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'SecurityChecklist',
      tabLabel: 'Security Checklist',
      icon: 'fa-solid fa-shield-halved',
      data: [
        {
          name: OpportunityItem.getSecurityChecklistContent,
          label: 'Vendor',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'CommissionRates',
      tabLabel: 'Commission Rates',
      icon: 'fa-solid fa-magnifying-glass-chart fa-2x',
      data: [
        {
          name: (item) => (
            <OpportunityCommissionRatesAdmin
              userId={item.PrimarySalesRepId}
              opportunityId={item.OpportunityId}
            />
          ),
          label: 'Ignored Surveys',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'Comments',
      tabLabel: 'Comments',
      icon: 'fa-solid fa-comment',
      data: [{ name: OpportunityItem.getCommentsContent, label: 'Comments', width: TabListTableCellWidthEnum.Table }],
    },
    {
      tabName: 'Attachments',
      tabLabel: 'Attachments',
      icon: 'fa-solid fa-paperclip',
      data: [
        { name: OpportunityItem.getAttachmentContent, label: 'Attachments', width: TabListTableCellWidthEnum.Table },
      ],
    },
    {
      tabName: 'Log',
      tabLabel: 'Log',
      icon: 'fa-solid fa-stream',
      data: [{ name: OpportunityItem.getLogContent, label: 'Log', width: TabListTableCellWidthEnum.Table }],
    },
    {
      tabName: 'Pricing',
      tabLabel: 'Pricing',
      icon: 'fa-solid fa-money-check-dollar-pen',
      rolekey: 'PricingDataTable',
      data: [{ name: OpportunityItem.getPricing, label: 'Pricing', width: TabListTableCellWidthEnum.Table }],
    },
    // {
    //   tabName: 'PricingSummary',
    //   tabLabel: 'Pricing Summary',
    //   icon: 'fa-solid fa-money-check-dollar-pen',
    //   rolekey: 'PricingDataTable',
    //   data: [
    //     { name: OpportunityItem.getPricingSummary, label: 'Pricing Summary', width: TabListTableCellWidthEnum.Table },
    //   ],
    // },
    {
      tabName: 'AdjPricingSummary',
      tabLabel: 'Adj. Pricing Summary',
      icon: 'fa-solid fa-money-check-dollar-pen',
      rolekey: 'PricingDataTable',
      data: [
        {
          name: OpportunityItem.getAdjustedPricingSummary,
          label: 'Adj. Pricing Summary',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'ServicesSummary',
      tabLabel: 'Services Summary',
      icon: 'fa-solid fa-money-check-dollar-pen',
      rolekey: 'PricingDataTable',
      data: [
        { name: OpportunityItem.getServicesSummary, label: 'Services Summary', width: TabListTableCellWidthEnum.Table },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Id',
        orderById: 'OpportunityId',
        data: (item) => OpportunityItem.GetDetailCellContent(item),
        type: FieldTypesEnum.Navigation,
        minWidth: 50,
      },
      {
        label: 'Opp. Id',
        orderById: 'OpportunityId',
        data: 'OpportunityId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 50,
      },
      {
        label: 'Name',
        orderById: 'Name',
        data: (item) => (
          <LongText
            text={item.Name}
            maxLength={40}
          />
        ),
        minWidth: 50,
      },
      {
        label: 'Follow Up By Date',
        orderById: 'FollowUpByDate',
        data: 'FollowUpByDate',
        minWidth: 50,
        tableminWidth: '125px',
      },
      { label: 'Office Name', orderById: 'OfficeName', data: 'OfficeName', minWidth: 50, tableminWidth: '100px' },
      {
        label: 'Client Name',
        orderById: 'ClientName',
        data: (item) => (
          <LongText
            text={item.ClientName}
            maxLength={40}
          />
        ),
        minWidth: 50,
        tableminWidth: '150px',
      },
      { label: 'Status', orderById: 'Status', data: 'StatusName', minWidth: 100 },
      {
        label: 'Date Proposal Sent On',
        orderById: 'ProposalSentOn',
        data: 'ProposalSentOn',
        minWidth: 70,
        tableminWidth: '150px',
      },
      {
        label: 'Est Value',
        orderById: 'EstValue',
        data: (item) => moneyHelper.toMoneyFormat(item.EstValue, item.OpportunityCurrency),
        minWidth: 50,
        tableminWidth: '150px',
      },
      {
        label: 'Probability',
        orderById: 'Probability',
        data: (item) => (item.Probability === null ? ' ' : `${item.Probability}%`),
        minWidth: 50,
        tableminWidth: '100px',
      },
      { label: 'Est Close Date', orderById: 'EstCloseOn', data: 'EstCloseOn', minWidth: 50, tableminWidth: '150px' },

      { label: 'Assigned To', orderById: 'AssigneToName', data: 'AssigneToName', minWidth: 50, tableminWidth: '150px' },
      {
        label: 'Primary Sales Rep',
        orderById: 'PrimarySalesRep',
        data: 'PrimarySalesRep',
        minWidth: 50,
        tableminWidth: '150px',
      },
      {
        label: ' ',
        orderById: '',
        data: OpportunityItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: 'text-center',
      },
    ];
  }

  static GetLeadCellContent(item) {
    if (!item.LeadId) return '';

    return urlHelper.getIconLinkComponentFigma(
      `${item.LeadName} (${item.LeadId})`,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'sales/search',
      `LeadId=${item.LeadId}`,
      'Open lead on a new tab'
    );
  }

  static GetClientCellContent(item) {
    if (!item.ClientId) return '';

    return urlHelper.getIconLinkComponentFigma(
      `${item.ClientName} (${item.ClientId})`,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'sales_clients/search',
      `OfficeId=&Name=${item.ClientId}`,
      'Open client on a new tab'
    );
  }

  static editGeneralFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static opportunityStatusChangeFunction = () => {
    alert('Empty function');
  };
  static ExtendActualEndDate = () => {
    alert('Empty function');
  };

  static opportunitySecurityChecklistFunction = () => {
    alert('Empty function');
  };

  static editOpportunitySecurityChecklistFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static getSecurityChecklistContent(item) {
    return (
      <ShowEntityData
        itemId={item.OpportunityId}
        entityName='OpportunitySecurityChecklist'
        type={OpportunitySecurityChecklistItem}
        serviceGetByIdFunction={OpportunitySecurityChecklistService.GetById}
        showRefreshButton={false}
      />
    );
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            roleKey: 'opportunity_edit',
            disabled: item.StatusCode === 11 || item.StatusCode === 12,
            onClick: () => OpportunityItem.editGeneralFunction(item.OpportunityId, item),
          },
          {
            iconName: 'fa-solid fa-retweet',
            text: 'Status Change',
            roleKey: 'opportunity_edit',
            onClick: () => OpportunityItem.opportunityStatusChangeFunction(item.OpportunityId, item),
          },
          {
            iconName: 'fa-solid fa-clock-two',
            text: 'Extend Actual End Date',
            roleKey: 'Opportuinity_faicon_ExtendActualEndDate',
            disabled: item.StatusCode !== 11,
            onClick: () => OpportunityItem.ExtendActualEndDate(item.OpportunityId, item),
          },
          {
            iconName: 'fa-solid fa-plus-circle',
            text: 'Create Service',
            roleKey: 'sales_opportunities_button',
            disabled: item.StatusCode === 11 || item.StatusCode === 12,
            onClick: () => OpportunityItem.createServiceFunction(item.OpportunityId, item),
          },
          {
            iconName: 'fa-solid fa-arrow-up-right-from-square',
            text: 'Edit Security Checklist',
            roleKey: 'opportunity_edit',
            onClick: () => OpportunityItem.editOpportunitySecurityChecklistFunction(item.OpportunityId, item),
          },
        ]}
      />
    );
  }

  static EstimatedValue(item) {
    return item.EstValue === null ? `` : `${item.EstValue}`;
  }

  static getCommentsContent(item) {
    return (
      <Comments
        entityTypeId={12}
        entityId={item.OpportunityId}
      />
    );
  }

  static getServicesSummary(item) {
    return <ServicesSummary OpportunityId={item.OpportunityId} />;
  }
  // static getPricingSummary(item) {
  //   return <PricingSummary OpportunityId={item.OpportunityId} />;
  // }

  static getAdjustedPricingSummary(item) {
    return <AdjustedPricingSummary OpportunityId={item.OpportunityId} />;
  }

  static getPricing(item) {
    return (
      <PricingMain
        OpportunityId={item.OpportunityId}
        OpportunityStatusCode={item.OpportunityStatusCode}
      />
    );
  }
  static getLogContent(item) {
    return (
      <LogComponent
        entityType='Opportunity'
        entityId={item.OpportunityId}
      />
    );
  }

  static getAttachmentContent(item) {
    return (
      <AttachmentsComponent
        entityTypeId={12}
        entityId={item.OpportunityId}
        enableAddNew={true}
      />
    );
  }

  getServices(item) {
    return (
      <ServiceItemAdmin
        OpportunityId={item.OpportunityId}
        StatusCode={item.StatusCode}
      />
    );
  }
  static GetDetailCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.OpportunityId,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'sales_opportunities/search',
      `OpportunityId=${item.OpportunityId}`,
      'Open up in a new tab'
    );
  }

  static createServiceFunction(item) {
    /*Placeholder*/
  }
}

export default OpportunityItem;
